import React, { useEffect, useRef, useState } from "react";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import { AnalyticsChartContent, TimePeriod, formatDate, timePeriodToDateRange } from "./analytics-chart-content/AnalyticsChartContent";
import styles from "./consumption-analytics.module.scss";
import { trackEnergyAnalyticsViewed } from "../../../../services/business-analytics/energyManagementEvents";

const TABS: { title: string; period: TimePeriod }[] = [
	{ title: "1M", period: TimePeriod.OneMonth },
	{ title: "3M", period: TimePeriod.ThreeMonths },
	{ title: "6M", period: TimePeriod.SixMonths },
	{ title: "1Y", period: TimePeriod.OneYear },
	{ title: "All", period: TimePeriod.All },
];

export const ConsumptionAnalyticsPage: React.FC = () => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const selectedPeriod = TABS[selectedIndex].period;
	// One event per period viewed: on arrival and on every tab change, not twice under StrictMode.
	const lastTrackedPeriod = useRef<TimePeriod | null>(null);

	useEffect(() => {
		if (lastTrackedPeriod.current === selectedPeriod) return;
		lastTrackedPeriod.current = selectedPeriod;
		trackEnergyAnalyticsViewed(selectedPeriod);
	}, [selectedPeriod]);

	const dateRange = timePeriodToDateRange(selectedPeriod);
	const fromDate = formatDate(dateRange.from);
	const toDate = formatDate(dateRange.to);

	return (
		<CustomerPageLayout title="Consumption Analytics">
			<div className={styles.pageContent}>
				{/* Stats + Chart — changes per tab */}
				<AnalyticsChartContent key={selectedPeriod} initialFilter={selectedPeriod} />

				{/* Tabs + date range */}
				<div className={styles.tabsSection}>
					<div className={styles.tabRow}>
						{TABS.map((tab, i) => (
							<button
								key={tab.title}
								className={`${styles.tab} ${i === selectedIndex ? styles.tabActive : ""}`}
								onClick={() => setSelectedIndex(i)}
							>
								{tab.title}
							</button>
						))}
					</div>
					<span className={styles.dateRange}>
						Showing {fromDate} — {toDate}
					</span>
				</div>

				{/* Footer */}
				<div className={styles.footer}>
					<div className={styles.divider} />
					<p className={styles.usageTrend}>
						Your usage is trending higher. Try identifying peak usage hours to lower your environmental footprint.
					</p>
				</div>
			</div>
		</CustomerPageLayout>
	);
};
